<template>
<div class="">
    <PageBreadcrumb />
    <!-- Media -->
    <section class="mediasec py-5">
        <div class="container">
            <div class="row">
                <div class="col-12 col-lg-9 mb-5 mb-lg-0">
                    <div class="media-gallery">
                        <div class="button-group filters-button-group mb-4">
                            <button class="button filter-button active" data-filter="all">All</button>
                            <button class="button filter-button" data-filter="Explos">Audios</button>
                            <button class="button filter-button" data-filter="Projects">Videos</button>
                            <button class="button filter-button" data-filter="Apostles">International</button>
                            <!-- <button class="button filter-button" data-filter="Events">Events</button> -->
                        </div>
                        <div id="lightgallery" class="demo-gallery">
                            <div class="grid row">
                                <div class="col-12 col-sm-6 col-lg-6 filter Explos" >
                                    <div class="gallery-item position-relative">
                                        <div class="gallery-image gradient-bt">
                                            <img class="img-fluid img-lg" src="../assets/images/news1.jpg" alt="">
                                        </div>
                                        <div class="gallery-overlay w-100 h-100 text-center" v-for="audios in audio" :key="audios.nid">
                                            <div class="content d-table w-100 h-100">
                                                <div class="content d-table-cell w-100 h-100 align-middle">
                                                    <div class="popup-gallery bg-white rounded-0 mx-auto pop-up-audio">
                                                        <div class="ready-player-3">
                                                            <audio>
                                                                <source :src="handleBase() + audios.field_video_media_1" type="audio/mpeg">
                                                            </audio>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6 col-lg-3 filter Projects">
                                    <div class="gallery-item position-relative">
                                        <div class="gallery-image gradient-bt">
                                            <img class="img-fluid img-sm" src="../assets/images/news2.jpg" alt="">
                                        </div>
                                        <div class="gallery-overlay w-100 h-100 text-center">
                                            <div class="content d-table w-100 h-100">
                                                <div class="content d-table-cell w-100 h-100 align-middle">
                                                    <div class="popup-gallery bg-white rounded-50 mx-auto">
                                                        <a href="../assets/images/news2.jpg" class="text-light"><img src="../assets/images/ezikel.png" alt="" class="img-fluid" /></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6 col-lg-3 filter Apostles">
                                    <div class="gallery-item position-relative" v-for="videos in media" :key="videos.nid">
                                        <div class="gallery-image gradient-bt">
                                            <img class="img-fluid img-sm" src="../assets/images/news2.jpg" alt="">
                                        </div>
                                        <div class="gallery-overlay w-100 h-100 text-center">
                                            <div class="content d-table w-100 h-100">
                                                <div class="content d-table-cell w-100 h-100 align-middle">
                                                    <div class="popup-youtube bg-white rounded-50 mx-auto">
                                                        <a v-bind:href="videos.field_video_media" class="text-light popup-youtube-a"><i class="fa fa-play"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6 col-lg-3 filter Projects">
                                    <div class="gallery-item position-relative">
                                        <div class="gallery-image gradient-bt">
                                            <img class="img-fluid img-sm" src="../assets/images/news2.jpg" alt="">
                                        </div>
                                        <div class="gallery-overlay w-100 h-100 text-center">
                                            <div class="content d-table w-100 h-100">
                                                <div class="content d-table-cell w-100 h-100 align-middle">
                                                    <div class="popup-gallery bg-white rounded-50 mx-auto">
                                                        <a href="../assets/images/news2.jpg" class="text-light"><img src="../assets/images/ezikel.png" alt="" class="img-fluid" /></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="gallery-item position-relative">
                                        <div class="gallery-image gradient-bt">
                                            <img class="img-fluid img-sm" src="../assets/images/news3.jpg" alt="">
                                        </div>
                                        <div class="gallery-overlay w-100 h-100 text-center">
                                            <div class="content d-table w-100 h-100">
                                                <div class="content d-table-cell w-100 h-100 align-middle">
                                                    <div class="popup-gallery bg-white rounded-50 mx-auto">
                                                        <a href="../assets/images/news3.jpg" class="text-light"><img src="../assets/images/ezikel.png" alt="" class="img-fluid" /></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6 col-lg-3 filter Apostles">
                                    <div class="gallery-item position-relative">
                                        <div class="gallery-image gradient-bt">
                                            <img class="img-fluid img-sm" src="../assets/images/news2.jpg" alt="">
                                        </div>
                                        <div class="gallery-overlay w-100 h-100 text-center">
                                            <div class="content d-table w-100 h-100">
                                                <div class="content d-table-cell w-100 h-100 align-middle">
                                                    <div class="popup-youtube bg-white rounded-50 mx-auto">
                                                        <a href="http://www.youtube.com/watch?v=0O2aH4XLbto" class="text-light popup-youtube-a"><i class="fa fa-play"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="gallery-item position-relative">
                                        <div class="gallery-image gradient-bt">
                                            <img class="img-fluid img-sm" src="../assets/images/news3.jpg" alt="">
                                        </div>
                                        <div class="gallery-overlay w-100 h-100 text-center">
                                            <div class="content d-table w-100 h-100">
                                                <div class="content d-table-cell w-100 h-100 align-middle">
                                                    <div class="popup-youtube bg-white rounded-50 mx-auto">
                                                        <a href="http://www.youtube.com/watch?v=0O2aH4XLbto" class="text-light popup-youtube-a"><i class="fa fa-play"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6 col-lg-6 filter Explos">
                                    <div class="gallery-item position-relative">
                                        <div class="gallery-image gradient-bt">
                                            <img class="img-fluid img-lg" src="../assets/images/news1.jpg" alt="">
                                        </div>
                                        <div class="gallery-overlay w-100 h-100 text-center">
                                            <div class="content d-table w-100 h-100">
                                                <div class="content d-table-cell w-100 h-100 align-middle">
                                                    <div class="popup-gallery bg-white rounded-50 mx-auto">
                                                        <a href="images/news1.jpg" class="text-light"><i class="fa fa-plus popup-btn"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                           </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-3">
                    <!-- Start SideBarExtras -->
                    <SideBarExtras />
                    <hr>

                    <!-- Start Latest News Sidebar -->
                    <LatestNews />
                    <!-- End Latest News Sidebar -->
                </div>
            </div>
        </div>
    </section>
    <!-- End Media -->
</div>
</template>

<script>
import PageBreadcrumb from '@/components/PageBreadcrumb';
import $ from 'jquery';
import LatestNews from "../components/LatestNews";
import SideBarExtras from "../components/SideBarExtras";
import axios from "axios";
import GreenAudioPlayer from "../assets/js/green-audio-player";
import "magnific-popup";

export default {
    name: 'Media',
    data(){
        return {
            value: "",
            media: [],
            audio: []
        }
    },
    components:{
        PageBreadcrumb, LatestNews, SideBarExtras
    },
    mounted(){
        $(document).ready(function ($) {
            $(".filter-button").click(function(){
                this.value = $(this).attr('data-filter');
                $('.filter-button').removeClass('active');
                $(this).addClass('active');
                if(this.value == "all")
                {
                    $('.filter').show('1000');
                }
                else{
                    $('.filter').removeClass('active');
                    $(".filter").not('.'+this.value).hide('3000');
                    $('.filter').filter('.'+this.value).show('3000');
                }
            });

            //magnificPopup
            $('.popup-gallery').magnificPopup({
                delegate: 'a',
                type: 'image',
                mainClass: 'mfp-img-mobile',
                gallery: {
                    enabled: true,
                    navigateByImgClick: true,
                    preload: [0,1]
                },
            });

            //magnificPopup Video
            $('.popup-youtube-a').magnificPopup({
                disableOn: 700,
                type: 'iframe',
                mainClass: 'mfp-fade',
                removalDelay: 160,
                preloader: false,
                fixedContentPos: false
            });
        });
        axios
            .get('https://api.fifmi.org.au/api/media')
            .then(result => {
                for (var i = 0; i < result.data.length; i++) {
                    if(result.data[i].field_domain_access.includes('fifmi') && result.data[i].field_media_type === "Videos"){
                        this.media.push(result.data[i])
                    }
                    if(result.data[i].field_domain_access.includes('fifmi') && result.data[i].field_media_type === "Audio"){
                        this.audio.push(result.data[i])
                    }
                }
            });
    },
    updated() {
        this.$nextTick(function () {
            GreenAudioPlayer.init({
                selector: '.ready-player-3',
                stopOthersOnPlay: true
            });
        });
    },
    methods: {
        handleBase: function () {
            return "https://www.fifmi.org.au"
        }
    }
}
</script>
